import type { PublicUser } from '@nestjs-boilerplate/types';
import { atom, createStore } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// Create a single shared store instance for the entire app
export const store = createStore();

// Persistent storage for access token
export const accessTokenAtom = atomWithStorage<string | null>('accessToken', null);

// User state (not persisted - refreshed on app load)
export const userAtom = atom<PublicUser | null>(null);

// Derived atom for authentication status
export const isAuthenticatedAtom = atom((get) => {
  const token = get(accessTokenAtom);
  const user = get(userAtom);
  return !!token && !!user;
});

// Helper to get current auth state synchronously (for route guards)
export function getAuthState() {
  return {
    accessToken: store.get(accessTokenAtom),
    user: store.get(userAtom),
    isAuthenticated: store.get(isAuthenticatedAtom),
  };
}

// Helper to set auth state
export function setAuthState(accessToken: string, user: PublicUser) {
  store.set(accessTokenAtom, accessToken);
  store.set(userAtom, user);
}

// Helper to clear auth state
export function clearAuthState() {
  store.set(accessTokenAtom, null);
  store.set(userAtom, null);
}

// Helper to update user state (e.g., after account setup)
export function updateUser(user: PublicUser) {
  store.set(userAtom, user);
}
